module.exports = __webpack_public_path__ + "static/media/invitado2.eb8fc199.jpg";